import classNames from 'classnames';

import * as api from '../../api';
import * as utils from '../../utils';

import styles from './index.module.css';

type Size = 'Small' | 'Large';
type Color = 'Standard' | 'Inverse';

interface Props {
  provider: Pick<
    api.User.UserIdentification,
    'firstName' | 'lastName' | 'previsitImageUrl'
  >;
  size?: Size;
  color?: Color;
  border?: boolean;
  className?: string;
}

export const ProviderImage: React.FC<Props> = ({
  provider,
  size = 'Large',
  color = 'Standard',
  border = true,
  className,
}) => {
  const providerImageSrc = utils.getPrevisitAsset(
    provider.previsitImageUrl || '',
  );
  const maybeFirstNameInitial = provider.firstName?.charAt(0).toUpperCase();
  const maybeLastNameInitial = provider.lastName?.charAt(0).toUpperCase();
  const initials = [maybeFirstNameInitial, maybeLastNameInitial]
    .filter(Boolean)
    .join('');
  return providerImageSrc ? (
    <div
      className={classNames(
        styles.Image,
        styles[size],
        styles[color],
        border ? styles.Border : '',
        className,
      )}
      style={{ backgroundImage: `url(${providerImageSrc})` }}
    />
  ) : (
    <div
      className={classNames(
        styles.Initials,
        styles[size],
        styles[color],
        border ? styles.Border : '',
        className,
      )}
    >
      {initials}
    </div>
  );
};

export default ProviderImage;
